export function PhotoZoomIsEnabled(
  zoomIsEnabled: boolean,
  PhotoZoomValue: number,
  BaseZoomValue: number
) {
  if (zoomIsEnabled) return PhotoZoomValue
  return BaseZoomValue
}
